module.exports = __webpack_public_path__ + "static/media/arbre2.868d4352.jpg";